import {
  Col,
  Row,
  Layout,
  Input,
  Button,
  Typography,
  Form,
  Select,
  Card
} from "antd";
import { useParams , useNavigate } from "react-router-dom";

const { Content } = Layout;
const { Option } = Select;
const { Title} = Typography;

type Props = {};

const ConfigSystem = (props: Props) => {

  const params = useParams();
  const { id } = useParams();
  const { name } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const truncateTitle = (title: any, maxLength: any) => {
    if (title.length > maxLength) {
      return title.substring(0, maxLength) + "...";
    }
    return title;
  };
  


  return (
    <Layout>
      <Content style={{ padding: "20px 30px 20px 30px" }}>
        {/* head */}
        <div>
          <Row>
            <Col>
              <Title level={2} style={{ marginBottom: "0px", color: "#cccccc", cursor: "pointer" }} onClick={() => { navigate("/setting") }}>System Setting {">"}&nbsp; </Title>
            </Col>
            <Col>
              <Title level={2} style={{ marginBottom: "0px" }}>{truncateTitle(name , 30)}</Title>
            </Col>
          </Row>
          <hr />
        </div>
      </Content>



      {/* form */}
      <Content style={{ padding: "0px 30px 0px 30px" }}>
        <Form form={form} layout="horizontal" labelCol={{ span: 4 }}
          wrapperCol={{ span: 10 }}>
          <Card title="Resource">
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  label="หน่วยประมวลผล (CPU)"
                  name="cpu"
                  rules={[{ required: true, message: 'กรุณาเลือก CPU' }]}
                >
                  <Select placeholder="เลือก CPU">
                    <Option value="Intel Core i9-14900HX">Intel Core i9-14900HX</Option>
                    <Option value="AMD Ryzen 9 5950X">AMD Ryzen 9 5950X</Option>
                    {/* Add more options as needed */}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="หน่วยความจำ (Ram)"
                  name="ram"
                  rules={[{ required: true, message: 'กรุณากรอกขนาด Ram' }]}
                >
                  <Input placeholder="10 GB" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="การ์ดประมวลผลกราฟฟิก (GPU)"
                  name="gpu"
                  rules={[{ required: true, message: 'กรุณาเลือก GPU' }]}
                >
                  <Select placeholder="เลือก GPU">
                    <Option value="NVIDIA GeForce RTX 4090">NVIDIA GeForce RTX 4090</Option>
                    <Option value="AMD Radeon RX 6900XT">AMD Radeon RX 6900XT</Option>
                    {/* Add more options as needed */}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  label="พื้นที่ความจุ (Disk)"
                  name="disk"
                  rules={[{ required: true, message: 'กรุณากรอกขนาด Disk' }]}
                >
                  <Input placeholder="10 GB" />
                </Form.Item>
              </Col>
            </Row>
          </Card>


          <Row justify="end" style={{ marginTop: "20px" }}>
            <Button style={{ marginRight: '10px' }} onClick={() => navigate('/setting')}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Row>
        </Form>

      </Content>
    </Layout>
  );
};

export default ConfigSystem;